module.exports = __webpack_public_path__ + "files/b18263c816a22838d23991e7d432d717.png";